import { z } from 'zod'

import { DateZod } from '../common'
import { LocalizedValueZod } from '../localization'

export const TermsOfUseZod = z.object({
  value: LocalizedValueZod,
  versionDate: DateZod.nullish().default(null),
})
